var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    { staticClass: "padding-top-5xl", attrs: { id: "fa7" } },
    [
      _c("div", { staticClass: "row text-center" }, [
        _c("div", { staticClass: "column-12" }, [
          _c(
            "h2",
            {
              staticClass: "text-uppercase size-md with-anchor",
              staticStyle: {
                "letter-spacing": "var(--letter-spacing-3xl)",
                "font-weight": "var(--font-weight-black)",
                color: "var(--fa-dk-yellow)",
              },
            },
            [
              _c("anchor-link", {
                attrs: {
                  anchor: "#fa7",
                  "link-color": "yellow",
                  "anchor-name": "Announcing Font Awesome 7",
                },
              }),
              _vm._v("\n        New Recipe. Same Great Taste.\n      "),
            ],
            1
          ),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _c(
            "p",
            { staticClass: "line-length-xl margin-auto" },
            [
              _vm._v(
                "\n        The next generation of the internet's favorite icon library and toolkit is here. Featuring more icons, better performance, and new ways to make your\n        designs look (and taste?) great.\n        "
              ),
              _c(
                "site-link",
                {
                  attrs: { to: { name: "plans" } },
                  nativeOn: {
                    click: function ($event) {
                      return _vm.$posthog.capture("upgrade_link_click", {
                        context: "home_view",
                      })
                    },
                  },
                },
                [_vm._v("Available now in all Pro plans")]
              ),
              _vm._v("!\n      "),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "column-12 tablet:column-8 tablet:offset-2" },
          [
            _c(
              "form",
              {
                staticClass:
                  "icons-search form line-length-md padding-y-4xl margin-bottom-sm margin-auto",
                staticStyle: { "--form-button-margin": "0" },
                on: {
                  submit: function ($event) {
                    $event.preventDefault()
                    return _vm.search.apply(null, arguments)
                  },
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "with-icon-before",
                    staticStyle: {
                      "--input-with-icon-color": "var(--fa-navy)",
                      "--input-border-color": "var(--fa-navy)",
                      "--input-placeholder-color": "var(--fa-md-gravy)",
                    },
                  },
                  [
                    _c("font-awesome-icon", {
                      staticStyle: { "line-height": "1" },
                      attrs: { icon: _vm.$v7.solid.faMagnifyingGlass },
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass: "sr-only",
                        attrs: { for: "icons-search" },
                      },
                      [_vm._v("\n            Search for Icons\n          ")]
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.query,
                          expression: "query",
                        },
                      ],
                      staticClass: "rounded",
                      attrs: {
                        id: "search",
                        type: "text",
                        name: "icons-search",
                        placeholder: `Search for icons...`,
                      },
                      domProps: { value: _vm.query },
                      on: {
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.query = $event.target.value
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c(
                      "button",
                      { staticClass: "sr-only", attrs: { type: "submit" } },
                      [_vm._v("\n            Search for Icons\n          ")]
                    ),
                  ],
                  1
                ),
              ]
            ),
          ]
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "fa7-pro-features-card-grid",
          staticStyle: { "--top-tag-margin-top": "0" },
        },
        [
          _c(
            "site-link",
            {
              staticClass: "card-1 card roomy white with-top-tag",
              staticStyle: {
                height: "100%",
                "--card-header-background": "var(--white)",
                "--card-header-color": "var(--fa-navy)",
              },
              attrs: {
                to: _vm.$search({ iconCollections: ["pro-collection"] }),
              },
            },
            [
              _c("span", { staticClass: "tag top yellow" }, [
                _vm._v("Updated!"),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "section padding-y-0 display-flex align-center",
                  staticStyle: { overflow: "hidden" },
                },
                [
                  _c("img", {
                    attrs: {
                      src: "https://img.fortawesome.com/1ce05b4b/v7-icon-grids.png",
                      alt: "Illustration of Version 7 Icon Key Frames",
                    },
                  }),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "header padding-bottom-0",
                  staticStyle: { "text-align": "left" },
                },
                [
                  _c("h4", [_vm._v("Revamped + Refreshed Icons")]),
                  _vm._v(" "),
                  _c("p", { staticClass: "muted" }, [
                    _vm._v(
                      "We've lovingly refined the designs for most of our core icons, using more consistent keyshapes and square canvases."
                    ),
                  ]),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "site-link",
            {
              staticClass: "card-2 card roomy header yellow with-top-tag",
              staticStyle: { height: "100%" },
              attrs: { to: _vm.$search({ new: true }) },
            },
            [
              _c("span", { staticClass: "tag top secondary" }, [
                _vm._v("New!"),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "section padding-y-0 display-flex align-center",
                  staticStyle: { overflow: "hidden" },
                },
                [
                  _c("img", {
                    attrs: {
                      src: "https://img.fortawesome.com/1ce05b4b/v7-new-icon.png",
                      alt: "Fresh new icons for Version 7",
                    },
                  }),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "header padding-bottom-0",
                  staticStyle: { "text-align": "left" },
                },
                [
                  _c("h4", [_vm._v("Fresh New Icons")]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "The initial release of Font Awesome 7 includes over 300 brand-new icons, with more on the way!"
                    ),
                  ]),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "site-link",
            {
              staticClass: "card-3 card with-top-tag inverted margin-bottom-0",
              attrs: { to: _vm.$docs("/web/add-icons/icon-wizard") },
            },
            [
              _c(
                "div",
                { staticClass: "text-left padding-bottom-lg" },
                [
                  _c("font-awesome-icon", {
                    attrs: {
                      icon: _vm.$v7.solid.faSquareDashedCirclePlus,
                      size: "2x",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "text-left" }, [
                _c("h4", [_vm._v("New Modifiers!")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "Create 11+ million possible icons with the Icon Wizard."
                  ),
                ]),
              ]),
            ]
          ),
          _vm._v(" "),
          _c(
            "site-link",
            {
              staticClass: "card-4 card with-top-tag margin-bottom-0",
              attrs: { to: _vm.$docs("/web/add-icons/upload-icons") },
            },
            [
              _c(
                "div",
                { staticClass: "text-left padding-bottom-lg" },
                [
                  _c("font-awesome-icon", {
                    attrs: { icon: _vm.$v7.solid.faCloudArrowUp, size: "2x" },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "text-left" }, [
                _c("h4", [_vm._v("Icon Upload!")]),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "Easily upload new icons to use alongside existing Font Awesome icons."
                  ),
                ]),
              ]),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "padding-top-3xl" },
        [
          _c(
            "h2",
            {
              staticClass:
                "text-uppercase size-md text-center margin-bottom-2xl",
              staticStyle: {
                "letter-spacing": "var(--letter-spacing-3xl)",
                "font-weight": "var(--font-weight-black)",
              },
            },
            [_vm._v("\n      Included Icon Packs\n    ")]
          ),
          _vm._v(" "),
          _c("icon-pack-cards", {
            attrs: { "collection-name": "pro-collection", "add-brands": "" },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("h1", { staticClass: "h2 margin-y-md" }, [
      _vm._v("\n        Font Awesome 7\n        "),
      _c(
        "span",
        {
          staticClass: "tag yellow margin-left-xs size-2xs",
          staticStyle: {
            "--tag-border-radius": "var(--border-radius-sm)",
            "--tag-padding":
              "var(--spacing-3xs) var(--spacing-2xs) var(--spacing-2xs) var(--spacing-sm)",
          },
        },
        [
          _c(
            "span",
            {
              staticStyle: {
                "font-size": "var(--font-size-xs)",
                "font-weight": "var(--font-weight-black)",
                "letter-spacing": "var(--letter-spacing-3xl)",
              },
            },
            [_vm._v("Pro")]
          ),
        ]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }